import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMenuDeepLink } from 'config/menuDeepLinks';

/**
 * A hook that listens for route changes and scrolls to the top of the page.
 *
 * It uses the `useLocation` hook from `react-router-dom` to listen for location changes.
 *
 * When the location's path changes, it uses `window.scrollTo` to scroll to the top
 * of the page.
 *
 * Menu deep-link routes (/liquor, see config/menuDeepLinks.js) are exempt: they
 * are supposed to land the visitor scrolled down at the menu, and Menu.jsx owns
 * that scroll once its categories resolve. Snapping to the top here would race
 * it and flash the hero first.
 *
 * @returns {null} This hook does not render anything.
 * Example usage:
 *
 * ```jsx
 * import RouteToTop from './RouteToTop';
 *
 * function App() {
 *   return (
 *     <div>
 *       <RouteToTop />
 *     </div>
 *   );
 * }
 * ```
 */

const RouteToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (getMenuDeepLink(pathname)) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default RouteToTop;
